// Compute upcoming "team moments" (birthdays + work anniversaries) from team
// profiles. Pure function with safe date parsing: date-only strings like
// "1990-06-20" are parsed as LOCAL dates so they never shift a day across
// timezones (the classic new Date("YYYY-MM-DD") UTC-midnight bug).

function parseLocalDate(dateStr) {
  if (!dateStr) return null;
  const datePart = String(dateStr).split('T')[0];
  const parts = datePart.split('-').map(Number);
  if (parts.length < 3 || parts.some((n) => Number.isNaN(n))) return null;
  const d = new Date(parts[0], parts[1] - 1, parts[2]);
  return Number.isNaN(d.getTime()) ? null : d;
}

// Next occurrence (this year or next) of a given month/day relative to `now`.
// Handles year-wrap and Feb 29 -> Feb 28 in a non-leap year.
function nextOccurrence(monthIndex, day, now) {
  const make = (y) => {
    let d = new Date(y, monthIndex, day);
    if (d.getMonth() !== monthIndex) d = new Date(y, 1, 28); // Feb 29 fallback
    return d;
  };
  const todayMid = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  let occ = make(now.getFullYear());
  if (occ < todayMid) occ = make(now.getFullYear() + 1);
  return occ;
}

export function getTeamMoments(profiles, { now = new Date(), windowDays = 30 } = {}) {
  const todayMid = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const dayMs = 86400000;
  const moments = [];

  for (const p of profiles || []) {
    const bd = parseLocalDate(p.dob);
    if (bd) {
      const occ = nextOccurrence(bd.getMonth(), bd.getDate(), now);
      const daysAway = Math.round((occ - todayMid) / dayMs);
      if (daysAway >= 0 && daysAway <= windowDays) {
        moments.push({ type: 'birthday', profile: p, date: occ, daysAway });
      }
    }
    const hd = parseLocalDate(p.hire_date);
    if (hd) {
      const occ = nextOccurrence(hd.getMonth(), hd.getDate(), now);
      const daysAway = Math.round((occ - todayMid) / dayMs);
      if (daysAway >= 0 && daysAway <= windowDays) {
        moments.push({
          type: 'anniversary',
          profile: p,
          date: occ,
          daysAway,
          years: occ.getFullYear() - hd.getFullYear(),
        });
      }
    }
  }

  moments.sort((a, b) => a.daysAway - b.daysAway);
  return moments;
}
